import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { BUSINESS_ERROR_CODES, validErrorMessageCode } from '../../../const/status-and-error-codes';
import { ConfigContext } from '../../../context';
import ErrorMessage from './ErrorMessage';
import { translate } from '../../../strings/i18n';
import getImages from '../helpers/get-images';
import ExpiredMembershipMessageBox from '../../../main-container/components/ExpiredMembershipMessageBox';
import NotEligibleMessageBox from '../../../main-container/components/NotEligibleMessageBox';
import NoEligibleMembersFound from '../../../main-container/components/NoEligibleMembersFound';
const CardHoldersErrors = ({ isSamsClient = false, businessErrorCode }) => {
    const { config } = useContext(ConfigContext);
    const { error, ladyWarning } = getImages({ config });
    const addressChangedSubTitle = isSamsClient
        ? translate('errorMessages.addressChangedSams')
        : translate('errorMessages.addressChanged');
    const defaultError = {
        image: error,
        id: 'mch-error-message',
        title: translate('errorMessages.troubleRetrievingInformation'),
        subTitle: translate('errorMessages.tryAgainLater')
    };
    const showErrorMessageComponent = Boolean(businessErrorCode && validErrorMessageCode.includes(businessErrorCode));
    const displayBusinessErrorInitialScreen = {
        [BUSINESS_ERROR_CODES.NO_ELIGIBLE_MEMBERS_FOUND]: (_jsx(NoEligibleMembersFound, {})),
        [BUSINESS_ERROR_CODES.EXPIRED_MEMBERSHIP]: _jsx(ExpiredMembershipMessageBox, {}),
        [BUSINESS_ERROR_CODES.NOT_ELIGIBLE_MEMBERS]: _jsx(NotEligibleMessageBox, {})
    };
    const errorsList = [
        {
            errorListProps: {
                image: ladyWarning,
                id: 'mch-primary-cardholder',
                title: translate('errorMessages.addPrimaryHolder.title'),
                subTitle: translate('errorMessages.addPrimaryHolder.subTitle'),
                extraInfo: translate('errorMessages.addPrimaryHolder.extraInfo')
            },
            rule: businessErrorCode === BUSINESS_ERROR_CODES.PRIMARY_CARDHOLDER
        },
        {
            errorListProps: {
                image: ladyWarning,
                id: 'mch-address-business-error',
                title: translate('errorMessages.notEligibleAccount'),
                subTitle: addressChangedSubTitle
            },
            rule: businessErrorCode === BUSINESS_ERROR_CODES.ADDRESS
        },
        {
            errorListProps: {
                image: ladyWarning,
                id: 'mch-profanity',
                title: translate('errorMessages.profanity.title'),
                subTitle: translate('errorMessages.profanity.unapprovedName')
            },
            rule: businessErrorCode === BUSINESS_ERROR_CODES.PROFANITY
        },
        {
            errorListProps: {
                image: ladyWarning,
                id: 'mch-first-name-business-error',
                title: translate('errorMessages.notEligibleAccount'),
                subTitle: translate('errorMessages.nameChanged')
            },
            rule: businessErrorCode === BUSINESS_ERROR_CODES.FIRST_NAME
        },
        {
            errorListProps: {
                image: error,
                id: 'mch-stolen-membership-business-error',
                title: translate('errorMessages.troubleRetrievingInformation'),
                subTitle: translate('errorMessages.pleaseContactUs')
            },
            rule: businessErrorCode === BUSINESS_ERROR_CODES.STOLEN_MEMBERSHIP ||
                businessErrorCode === BUSINESS_ERROR_CODES.DETAIL_MEMBERSHIP_ERROR
        }
    ];
    if (showErrorMessageComponent && businessErrorCode) {
        return displayBusinessErrorInitialScreen[businessErrorCode];
    }
    return (_jsx(ErrorMessage, { ...(errorsList.find(({ rule }) => rule)?.errorListProps ?? defaultError) }));
};
export default CardHoldersErrors;
